import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComputePageWindow } from './pagination.window';

/**
 * The mockup's `.pager` (grants.html:386-387, :963-966): centred `‹ 1 2 3 4 5 ›`
 * boxes, 34×34, radius 6, the active page solid accent; rendered only when there
 * is more than one page. With `Total` null (a supply with no countable set) the
 * pager is open-ended — `‹ N ›` with Next enabled by `HasNext`.
 */
@Component({
    standalone: false,
    selector: 'agu-pagination',
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss',
})
export class AGUPaginationComponent {
    @Input({ required: true }) Page!: number;
    @Input({ required: true }) PageSize!: number;
    @Input() Total: number | null = null;
    /** Open-ended mode only: whether a next page exists. Ignored when `Total` is known. */
    @Input() HasNext: boolean | null = null;

    @Output() PageChange = new EventEmitter<number>();

    get TotalPages(): number | null {
        return this.Total === null ? null : Math.max(1, Math.ceil(this.Total / Math.max(1, this.PageSize)));
    }

    get Visible(): boolean {
        return this.TotalPages === null ? this.Page > 1 || this.HasNext === true : this.TotalPages > 1;
    }

    get Pages(): number[] {
        return this.TotalPages === null ? [this.Page] : ComputePageWindow(this.Page, this.TotalPages);
    }

    get CanNext(): boolean {
        return this.TotalPages === null ? this.HasNext === true : this.Page < this.TotalPages;
    }

    GoTo(page: number): void {
        if (page < 1 || page === this.Page) return;
        if (this.TotalPages !== null && page > this.TotalPages) return;
        if (this.TotalPages === null && page > this.Page && !this.CanNext) return;
        this.PageChange.emit(page);
    }
}
